import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LandingScreenContainer } from '../styles/components/AnimatedOuterSpaceWrapper';
import starGroup from '../assets/images/star-group-6.png';
import starYellow from '../assets/images/star-yellow.svg';
import NextButton from '../components/Buttons/NextButton';
import EducatorResourcesLink from '../components/Links/EducatorResourcesLink';
import LottiePlayer from '../components/LottiePlayer';
import outerSpace from '../assets/lotties/outer-space.json';
import { Paths } from '../data/types';

export default function Landing() {
  const navigate = useNavigate();

  return (
    <LandingScreenContainer>
      <div className="top">
        <LottiePlayer
          data={outerSpace}
          width="100%"
          handleComplete={() => {}}
          shouldAutoplay
          shouldLoop
        />
        <div className="text-and-stars">
          <img src={starYellow} alt="" className="star left" />
          <div className="title">Starwriter</div>
          <NextButton
            isDisabled={false}
            buttonTouch={() => navigate(`/${Paths.GAME}`)}
          />
          <img src={starYellow} alt="" className="star right" />
        </div>
      </div>
      <div className="bottom">
        <img src={starGroup} alt="" className="star left" />
        <EducatorResourcesLink shouldCheckAccess />
      </div>
    </LandingScreenContainer>
  );
}
